export default {
  metadata: {
    version: '1.0.0',
    id: 'checkbox-1.0.0',
    name: 'JDSCheckbox',
    description:
      'Checkboxes are used within an interface to allow the user to select between one or more options.'
  },
  hierarchy: {
    'vertical-container': [
      {
        'horizontal-container': [
          {
            'control-container': ['control-icon']
          },
          'label-jds-text'
        ]
      },
      'jds_feedback_block',
      'helper-jds-text'
    ]
  },
  base: {
    'vertical-container': {
      hidden: false,
      'flex-direction': '{c_0}',
      'justify-content': '{c_1}',
      'align-items': '{c_2}',
      gap: '{c_3}',
      opacity: '{c_36}'
    },
    'horizontal-container': {
      hidden: false,
      'flex-direction': '{c_4}',
      'justify-content': '{c_5}',
      'align-items': '{c_6}',
      gap: '{c_7}',
      behavior: {
        hover: {},
        active: {},
        focus: {}
      }
    },
    'control-container': {
      hidden: false,
      'min-width': '{c_8}',
      'min-height': '{c_9}',
      'flex-direction': '{c_10}',
      'justify-content': '{c_11}',
      'align-items': '{c_12}',
      'background-color': '{c_13}',
      'border-radius': '{c_14}',
      'border-width': 1,
      'border-color': '{c_15}',
      show: true,
      behavior: {
        hover: {
          'border-color': '{c_16}'
        },
        active: {
          'border-color': '{c_17}'
        },
        focus: {
          'border-width': 4,
          'box-sizing': 'content-box',
          'border-color': '{c_18}'
        }
      }
    },
    'control-icon': {
      hidden: true,
      size: '{c_19}'
    },
    jds_feedback_block: {
      hidden: true,
      state: 'none',
      size: 'l'
    },
    'label-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false,
      'text-align': '{c_20}',
      behavior: {
        hover: {
          color: '{text_20}'
        },
        focus: {
          color: '{text_20}'
        }
      }
    },
    'helper-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false
    }
  },
  variant: {
    size: {
      small: {
        'control-container': {
          'min-width': '{c_21}',
          'min-height': '{c_22}'
        },
        'vertical-container': {
          gap: '{c_23}'
        },
        'control-icon': {
          size: '{c_24}'
        },
        jds_feedback_block: {
          size: 's'
        },
        'label-jds-text': {
          'font-family': '{text_147}',
          'font-size': '{text_146}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}'
        },
        'helper-jds-text': {
          'font-family': '{text_147}',
          'font-size': '{text_146}',
          'line-height': '{text_148}',
          'letter-spacing': '{text_149}',
          'font-weight': '{text_150}'
        }
      }
    },
    checked: {
      true: {
        'control-container': {
          'background-color': '{c_26}',
          'border-width': 0,
          behavior: {
            hover: {
              'background-color': '{c_27}'
            },
            active: {
              'background-color': '{c_28}'
            }
          }
        },
        'control-icon': {
          hidden: false,
          value: '{c_25}',
          color: '{c_29}'
        },
        'label-jds-text': {
          color: '{text_20}'
        }
      }
    },
    indeterminate: {
      true: {
        'control-container': {
          'background-color': '{c_31}',
          'border-width': 0,
          behavior: {
            hover: {
              'background-color': '{c_32}'
            },
            focus: {
              'background-color': '{c_33}'
            }
          }
        },
        'control-icon': {
          hidden: false,
          value: '{c_30}',
          color: '{c_34}'
        },
        'label-jds-text': {
          color: '{text_20}'
        }
      }
    },
    disabled: {
      true: {
        'vertical-container': {
          opacity: '{c_35}'
        },
        'horizontal-container': {
          disabled: true
        }
      }
    },
    state: {
      success: {
        jds_feedback_block: {
          hidden: false
        }
      },
      error: {
        jds_feedback_block: {
          hidden: false
        }
      },
      warning: {
        jds_feedback_block: {
          hidden: false
        }
      }
    }
  },
  api: {
    config: {
      checked: {
        values: [false, true],
        doc_description:
          'It can be used to programmatically make input active/inactive.'
      },
      indeterminate: {
        values: [false, true]
      },
      size: {
        values: ['medium', 'small'],
        doc_description: 'It can be used control the size of Checkbox.'
      },
      disabled: {
        values: [false, true],
        doc_description: 'It can be used to enable or disable Checkbox.'
      },
      state: {
        type: 'JDSFeedbackBlock.state',
        doc_description:
          'It can be used to provide success/error/warning state to Checkbox.',
        values: ['none', 'success', 'error', 'warning']
      }
    },
    data: {
      jds_feedback_block: {
        stateText: {
          type: 'string',
          name: 'stateText',
          doc_description:
            'It displays message with respect to its [state] selected.'
        },
        state: {
          type: 'JDSFeedbackBlock.state',
          name: 'state',
          doc_description:
            "It can be used to choose between states i.e. 'success','warning','error','none'."
        }
      },
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label',
          doc_description: 'It displays label of Checkbox.'
        }
      },
      'helper-jds-text': {
        value: {
          type: 'string',
          name: 'helperText',
          doc_description: 'It displays helper text of Checkbox.'
        }
      }
    },
    events: {
      'horizontal-container': {
        onClick: 'onClick'
      }
    },
    a11y: {
      'vertical-container': {
        properties: {
          role: {
            value: 'checkbox'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-checked': {
            name: '_ariaChecked'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
